import React, { useEffect, useState } from "react";

import { useFetchNoticesAparaitreQuery, useFetchNoticesDemandesQuery, useFetchNoticesQuery } from "../../redux/slice/api/FO/noticeApi";
import { IFilterNotice, dtoToFilter, filterToQuery, getDefaultFilterNotice } from "../../models/interfaces/IFilterNotice";
import { filterToQuery as filterToQueryMessage } from "../../models/interfaces/IFilterMessage";
import { filterToQuery as filterToQueryNoticeDemande } from "../../models/interfaces/IFilterNoticeDemande";
import CpntDataTable from "../../components/dataTable/CpntDataTable";
import { ITitle } from "../../models/interfaces/ITitle";
import { ILocation } from "../../models/interfaces/ILocation";
import { INotice} from "../../models/interfaces/INotice";
import NoticesFilter from "./components/NoticesFilter";
import CpntFacettes from "../../components/CpntFacettes";
import { IFacetteFiltre } from "../../models/interfaces/IFacette";
import { useKeycloak } from "@react-keycloak/web";
import HtmlRenderModalImage from "./components/HtmlRender/HtmlRenderImageICon";
import CpntPagination from "../../components/CpntPagination";
import HtmlRenderDisponibiliteEtendu from "./components/HtmlRender/HtmlRenderDisponibiliteEtendu";
import { IToggleView } from "../../models/interfaces/IToggleView";
import { useFetchmessagesEANQuery } from "../../redux/slice/api/FO/messageApi";
import { IFilterMessage } from "../../models/interfaces/IFilterMessage";
import { ModificationBloque, Modules, Type_Reponse_Message } from "../../config/helpers";
import CpntFacette from "../../components/CpntFacette";
import { useNavigate } from "react-router-dom";
import { IFilterNoticeDemande } from "../../models/interfaces/IFilterNoticeDemande";
import { toast } from "react-toastify";
import SpinnerEditeurPro from "./components/SpinnerEditeurPro";
import { filterToQueryNoticeAapraitre, IFilterNoticeAapraitre } from "../../models/interfaces/IFilterNoticeAapraitre";
import { Type_Return_Message } from "../../models/interfaces/IReturn_Parent";
import HtmlRenderFormatEbook from "./components/HtmlRender/HtmlRenderFormatEbook";

const PageModuleEspaceEditeur: React.FC = () => {
  const [listfilter, setListFilter] = useState<IFilterNotice>();
  const [searchParams, setSearchParams] = useState<IFilterNotice|undefined>(undefined);
  const [searchParamsNoticeAparaitre, setSearchParamsNoticeAparaitre] = useState<IFilterNoticeAapraitre|undefined>(undefined);
  const [searchParamsMessage, setSearchParamsMessage] = useState<IFilterMessage>();
  const [searchParamsNoticesDemandes, setSearchParamsNoticesDemandes] = useState<IFilterNoticeDemande>();
  const [limit, setLimit] = useState(-1);
  const [offset, setOffset] = useState(-1);
  //const [facettes, setFacettes] = useState<IFacetteFiltre[]>([]); // |null
  const [isDescending, setIsDescending] = useState<boolean|null>(null);
  const [sortField, setSortField] = useState("");

  const [numberOfResults, setNumberOfResults] = useState<number|null>(null);
  //const [initiateDownload, setInitiateDownload] = useState(false)
  //const [csvDataToDownload, setCsvDataToDownload] = useState(null)
  //const [editeur, setediteur] = useState(""); // État local pour stocker la valeur de l'entrée
  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  //const [selectedIds, setSelectedIds] = useState<string [] |undefined>();


  useEffect(() => {
    localStorage.removeItem("IFilterMessagesNotices");
    const _filterMessage: IFilterMessage = filterToQueryMessage({
      IdTypereponses: [Type_Reponse_Message.Nouveau,Type_Reponse_Message.TraitementEnCours],
      Offset:0,
      Limit: 1 // to be faster
    });
    setSearchParamsMessage(_filterMessage);

    const _filterNoticesDemandes: IFilterNoticeDemande = filterToQueryNoticeDemande({
      Offset:0,
      Limit: 1 // to be faster
    });
    setSearchParamsNoticesDemandes(_filterNoticesDemandes);
    const _filterNoticesAapraitre: IFilterNoticeAapraitre = filterToQueryNoticeAapraitre({
      Offset:0,
      Limit: 1 // to be fast
    });
    setSearchParamsNoticeAparaitre(_filterNoticesAapraitre);
  
  }, [])
   
  const { data: MessagesEANResult, isFetching: isFetchingMessagesEAN, error:errorMessagesEAN } = useFetchmessagesEANQuery(searchParamsMessage, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || searchParamsMessage === null || searchParamsMessage === undefined,
  });
  
  const { data: NoticesDemandesResult, isFetching: isFetchingNoticesDemandes, error:errorNoticesDemandes } = useFetchNoticesDemandesQuery(searchParamsNoticesDemandes, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || searchParamsNoticesDemandes === null || searchParamsNoticesDemandes === undefined,
  });


  useEffect(() => {
    const storedFilter = localStorage.getItem("IFilterNotices");
    //const storedSorter = localStorage.getItem("ISortStore");
    if (storedFilter !== null && storedFilter !== undefined) { // && storedSorter !== null && storedSorter !== undefined) {
      const filters = JSON.parse(storedFilter);
      setListFilter(filters);
      setOffset(filters.Offset ?? 0)
      setLimit(filters.Limit ?? 10)
    } else {
      setListFilter(getDefaultFilterNotice());
    }
  
    // if (storedSorter !== null && storedSorter !== undefined) {
    //   const currSorter:ISorter = JSON.parse(storedSorter);
    //   currSorter?.orderedcolumnid && setSortField(currSorter?.orderedcolumnid);
    //   currSorter?.orderedasc && setIsDescending(!currSorter?.orderedasc);
    // }
   
  }, []);

  useEffect(() => {
    if (listfilter && listfilter !== getDefaultFilterNotice()) {
      const _filter: IFilterNotice = filterToQuery({
        ...listfilter,
        ...(sortField !== "" && { SortField: sortField }),
        ...(isDescending !== null && { IsDescending: isDescending }),
        ...(limit >= 10 && { Limit: limit }),
        ...(offset >= 0 && { Offset: offset }) //&& limit > 0 && { Offset: Math.floor(offset / limit) +1 })
      });
     
      if (limit === -1 && listfilter?.Limit ) {
        setLimit(listfilter.Limit);
      } 
      if (offset === -1 && listfilter?.Offset) {
        setOffset(listfilter.Offset);
      } 

      setSearchParams(_filter);
      localStorage.setItem("IFilterNotices",JSON.stringify(_filter));
    }
  }, [listfilter, sortField, isDescending,offset, limit]); 

  const { data: NoticesResult, isFetching, error } = useFetchNoticesQuery(searchParams, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated 
      || (searchParams?.Auteur === "" && searchParams?.EanIsbn === "" && searchParams?.Collection === ""
         && (searchParams?.SocieteIds?.length ?? 0 )=== 0 && searchParams?.Titre === ""
      )
      || searchParams === undefined || listfilter === undefined,
  });
  const { data: NoticesAparaitreResult, isFetching: isFetchingAparaitre, error:errorAparaitre } = useFetchNoticesAparaitreQuery(searchParamsNoticeAparaitre, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || searchParams === null || searchParams === undefined,
  });
  
  useEffect(() => {
    if (NoticesResult?.Return_IdType_Message === Type_Return_Message.Erreur) {
      toast.error(NoticesResult?.Return_Message);
    } else {
      if (NoticesResult) {
        setNumberOfResults(NoticesResult?.Quantite ?? null);
        localStorage.setItem(
          "NoticesNavigator",
          JSON.stringify(NoticesResult?.Notices?.map(n => ({ Ean: n.Ean, idnotice: n.Id })))
        );
      }
      
    }
    
  }, [NoticesResult]);
  
  const applyFilter = (data: IFilterNotice) => {
    data.FacettesFiltre = [];
    setListFilter(data);
    setOffset(0);
    setLimit(10);
  }


  function getLibelleFacette(Libelle : string) {
    let returnLibelle = "";
    switch (Libelle?.toLowerCase()) {
      case "disponible" : {
        returnLibelle = "Disponible";
        break;
      }
      case "a-paraitre": {
        returnLibelle = "A Paraître";
        break;
      }
      case "manquant": {
        returnLibelle = "Manquant";
        break;
      }
      case "epuise": {
        returnLibelle = "Epuisé";
        break;
      }
      default: {
        returnLibelle = ""; // Optionnel : valeur par défaut
      }
    }
    return returnLibelle;
  }

  const actions: ILocation[] = [
    {
      PathsName: { Consulter: "/espaceediteur/noticedetails/[[Ean]]/[[Id]]" },
      State: { type_access: "" },
      ClassName: "bi-receipt fs-5 mb-2",
    },
    {
      PathsName: (index) => { 
        let statut = ModificationBloque(NoticesResult?.Notices[index]?.Source ?? "",NoticesResult?.Notices[index].Support?.supportId ?? "","") ? " (impossible)" : "";
        if (statut === "") {
          const nbDemande = (NoticesResult?.Notices[index]?.DemandesAuto ?? 0);
          statut = nbDemande > 0 ? ` (${nbDemande} en cours)` : "";
        }
        const lbl = `Modifications physiques et commerciales ${statut}`;
        return { [lbl] : "/espaceediteur/noticedetailsmodifauto/[[Ean]]/[[Id]]" }
      },
      State: { type_access: "" },
      //ClassName: "bi-pencil",
      ClassName: (index) => {
        let classname = ModificationBloque(NoticesResult?.Notices[index]?.Source ?? "",NoticesResult?.Notices[index].Support?.supportId ?? "","") ? "bi-pencil text-reddark fs-5 mb-2" : "";

        if (classname === "") {
          classname = (NoticesResult?.Notices[index]?.DemandesAuto ?? 0) > 0 ? "bi-pencil text-orange fs-5 mb-2" : "";
        }
         if (classname === "") {
          classname = "bi-pencil fs-5 mb-2"
        }

        return classname;
      },
      ActionCallBack: (index) => {
        const ModificationBloqueMessage = ModificationBloque(NoticesResult?.Notices[index]?.Source ?? "",NoticesResult?.Notices[index].Support?.supportId ?? "","Modifcations automatisés impossible pour cette notice.");
        if (ModificationBloqueMessage !== undefined) {
          toast.error(ModificationBloqueMessage);
          return false;
        } else {
          return true;
        }
      }
    },
    {
      //PathsName: { "Modifcations par message": "/espaceediteur/noticedetailsmessage/[[Ean]]/[[Id]]" },
      PathsName: (index) => { 
        let statut = ModificationBloque(NoticesResult?.Notices[index]?.Source ?? "",NoticesResult?.Notices[index].Support?.supportId ?? "","") ? " (impossible)" : "";
        if (statut === "") {
          const nbDemande = (NoticesResult?.Notices[index]?.DemandesMessages ?? 0);
          statut = nbDemande > 0 ? ` (${nbDemande} en cours)` : "";
        }
        const lbl = `Autres modifications ${statut}`;
        return { [lbl] : "/espaceediteur/noticedetailsmessage/[[Ean]]/[[Id]]" }
      },
      State: { type_access: "" },
      ClassName: (index) => {
        let classname = ModificationBloque(NoticesResult?.Notices[index]?.Source ?? "",NoticesResult?.Notices[index].Support?.supportId ?? "","") ? "bi-chat-left-text text-reddark  fs-5 mb-2" : "";
        
        if (classname === "") {
          classname = (NoticesResult?.Notices[index]?.DemandesMessages ?? 0) > 0 ? "bi-chat-left-text text-orange  fs-5 mb-2" : "";
        }
         if (classname === "") {
          classname = "bi-chat-left-text fs-5 mb-2"
        }
        return classname;
      },
      ActionCallBack: (index) => {
        const ModificationBloqueMessage = ModificationBloque(NoticesResult?.Notices[index]?.Source ?? "",NoticesResult?.Notices[index].Support?.supportId ?? "","Modifcations par message impossible pour cette notice.");
        if (ModificationBloqueMessage !== undefined) {
          toast.error(ModificationBloqueMessage);
          return false;
        } else {
          return true;
        }
      }
    },
  ];
  const toggleview : IToggleView = {
    ToggleImageFieldName: "ImageCouverture",
    ToggleTextFieldName: "resumeElectre",
  }
  const dataHeaderName: ITitle[] = [
    {
      Id: "",
      Name: <HtmlRenderModalImage />,
      Class: "",
    },
    {
      Id: "disponibiliteEtendue",
      Name: "Dispo",
      Class: "",
    },
    {
      Id: "FormatEbook",
      Name: "Format",
      Class: "",
    },
    {
      Id: "dateParution",
      Name: "Date Parution",
      Class: "",
      sorter: (a: INotice, b: INotice) =>
        0//a?.dateParution?.localeCompare(b?.dateParution),  //tri géré au niveau de l'API
    },
    {
      Id: "Auteur",
      Name: "Auteur",
      Class: "",
      sorter: (a: INotice, b: INotice) =>
        0//?.Auteur?.localeCompare(b?.Auteur),  //tri géré au niveau de l'API
    },
    {
      Id: "Titre",
      Name: "Titre",
      Class: "",
      sorter: (a: INotice, b: INotice) =>
        0//a?.Titre?.localeCompare(b?.Titre),  //tri géré au niveau de l'API
    },
    {
      Id: "Ean",
      Name: "Ean",
      Class: "",
      //sorter: (a: INotice, b: INotice) => a?.Ean?.localeCompare(b?.Ean),
    },
    {
      Id: "Editeur",
      Name: "Editeur",
      Class: "",
      sorter: (a: INotice, b: INotice) =>
        0//a?.Editeur?.localeCompare(b?.Editeur),  //tri géré au niveau de l'API
    },
    {
      Id: "prixTTC",
      Name: "Prix TTC",
      Class: "",
      sorter: (a: INotice, b: INotice) =>
        0//a?.prixTTC - b?.prixTTC, //tri géré au niveau de l'API
    },
    {
      Id: "distributeur",
      Name: "distributeur",
      Class: "",
      //sorter: (a: INotice, b: INotice) => a?.distributeur?.localeCompare(b?.distributeur),
    },

  ];

     const changeFacette = (filtre: IFacetteFiltre,checked: boolean ) => {
      setOffset(0)
      setListFilter(
        filterToQuery({
          ...listfilter,
          Offset:0,
          FacettesFiltre: checked 
          ? [...(searchParams?.FacettesFiltre ?? []), filtre]
          : searchParams?.FacettesFiltre?.filter(fac => fac.filtreName !== filtre.filtreName || fac.filtreValue !== filtre.filtreValue)
        })
      );
    }





  const dataItemsStyle = {
    ImageCouverture: "",
    Disponible:<HtmlRenderDisponibiliteEtendu tableau={true}/>,
    FormatEbook:<HtmlRenderFormatEbook />,
    DateParution: "",
    Auteur:"",
    Titre: "",
    Ean: "",
    Editeur: "",
    prixTTC: "",
    distributeur :"",
  };
  const navigate = useNavigate();

  const clickFacettteMessage = () => {
    const combinedData: IFilterMessage = {
      IdTypereponses: [
        Type_Reponse_Message.Nouveau,
        Type_Reponse_Message.TraitementEnCours
      ]
    };
    localStorage.setItem("IFilterMessagesNotices",JSON.stringify(combinedData));
    navigate("/messagesnotices")
   }

   const clickFacettteAuto = () => {
    const combinedData: IFilterMessage = {
      Offset:0,
      Limit:10
    };
    localStorage.setItem("IFilterNoticesDemandesNotices",JSON.stringify(combinedData));
    navigate("/modifautonotices")
   }

   const clickFacettteDateParution = () => {
    const combinedData: IFilterMessage = {
      Offset:0,
      Limit:10
    };
    localStorage.setItem("IFilterNoticesAapraitre",JSON.stringify(combinedData));
    navigate("/noticesaparaitre")
   }

  
  return (
    <>
     <div className="container text-start ">
     <div className="row pt-3 pb-5">
        <div className="col col-12 ">
          <h2 className="titreModule titre-bleu"><i className="bi-book pe-2" />{Modules.GestionDeVotreCatalogue}</h2>
        </div>
      </div>
     <div className="row justify-content-center pb-5">
     {errorNoticesDemandes && <div>Error</div>}
      {<CpntFacette  
            Libelle="Modifications physiques et commerciales"
            Quantite={NoticesDemandesResult?.Quantite ?? 0}
            SkeletonVisible={(isFetchingNoticesDemandes || !NoticesDemandesResult) ? true : false}
            cssClassOuterBox="col-12 col-md-6 col-lg-4 col-xl-4 col-xxl-3"
            cssClassInnerBox="facette-color-notification facette-style-twoline"
            FacetteSelected={false} 
            onChange={clickFacettteAuto} 
              />}
      {errorMessagesEAN && <div>Error</div>}
      {<CpntFacette  
            Libelle="Autres modifications"
            Quantite={MessagesEANResult?.Quantite ?? 0}
            SkeletonVisible={isFetchingMessagesEAN || !MessagesEANResult}
            cssClassOuterBox="col-12 col-md-6 col-lg-4 col-xl-4 col-xxl-3"
            cssClassInnerBox="facette-color-notification facette-style-twoline"
            FacetteSelected={false} 
            onChange={clickFacettteMessage} 
              />}
        {errorAparaitre && <div>Error</div>}
             
              <CpntFacette
                Libelle="Dates de parution à surveiller"
                Quantite={NoticesAparaitreResult?.Quantite ?? 0}
                SkeletonVisible={isFetchingAparaitre || !NoticesAparaitreResult}
                cssClassOuterBox="col-12 col-md-6 col-lg-4 col-xl-4 col-xxl-3"
                cssClassInnerBox={`facette-color-notification facette-style-twoline ${
                  NoticesAparaitreResult?.Quantite === 0 ? "facette-disabled" : ""
                }`}
                FacetteSelected={false}
                onChange={clickFacettteDateParution} 
                InfoBulle={
                  NoticesAparaitreResult?.Quantite === 0 
                    ? "Aucune notice concernée par l'alerte à paraître"
                    : ""
                }
                Disabled = {NoticesAparaitreResult?.Quantite === 0}
              />
     </div>
      <div className="row card mb-3 mt-2">
          {searchParams && (
            <>
              <NoticesFilter
                filter={dtoToFilter(searchParams)}
                changeFilter={applyFilter}
              />
            </>
          )}
        </div> 
        <div className="row ">
          <>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
  {NoticesResult?.Facettes && (
    <CpntFacettes
      getLibelleFacette={getLibelleFacette}
      FacettesSelected={searchParams?.FacettesFiltre}
      Facettes={NoticesResult?.Facettes}
      onChange={(filtre, checked) => changeFacette(filtre, checked)}
    />
  )}
   {/* {NoticesResult?.Notices && numberOfResults !== null && numberOfResults > 0 && (
    <>
         <button
            className="btn btn-secondary col-4 grandBoutton"
            style={{
              width: "25%",
              alignSelf: 'flex-start', 
              marginLeft: 'auto',
              margin: '5px' 
            }}
            type="submit"
            disabled={(selectedIds?.length || 0) <= 0}
          >
            Modification groupée
        </button>
    </>
   )} */}
</div>


        
          
              
          </>
          {numberOfResults !== null && NoticesResult?.Notices && 
            <div className="col-auto pb-3 pt-3">
              Nb de résultats :<b>&nbsp;{numberOfResults}&nbsp;</b>
   
            </div>
          }
          {isFetching ? (
           <SpinnerEditeurPro />
          ) : error ? (
            <div>Error</div>
          ) : (
            NoticesResult?.Notices && numberOfResults !== null && numberOfResults > 0 &&
              <>
              <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>
              <div className="card p-0 mb-2">
                <div className="table-responsive">
                  <CpntDataTable
                    data={NoticesResult && NoticesResult.Notices ? [...NoticesResult.Notices] : []}
                    dataHeader={dataHeaderName}
                    dataItemsStyle={dataItemsStyle}
                    actions={actions}
                    toggleview={toggleview}
                    // checkbox={true}
                    actualFilterPage="PageModuleEspaceEditeur"
                    updateSorter={setSortField}
                    updateDescending={setIsDescending}
                    //onSelectionChange={setSelectedIds}
                />
                </div>
              </div>
              <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>

              </>
          )}
        </div>
      </div>
    </>
  );
};

export default PageModuleEspaceEditeur;
